import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClampedFlangeCoupling = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 100,
	viewBox: "0 0 50.0 100.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 15.0 L 0.0 0.0 L 50.0 0.0 L 50.0 15.0 M 0.0 85.0 L 0.0 100.0 L 50.0 100.0 L 50.0 85.0 M 10.0 10.0 L 10.0 90.0 M 40.0 10.0 L 40.0 90.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgClampedFlangeCoupling;
